function declOfNum(number, titles) {
    var cases = [2, 0, 1, 1, 1, 2];
    return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
}
$(function(){
    $('.b-service-card__count').each(function(){
        var $context = $(this),
            $number = $('.b-service-card__count-number', $context),
            $text = $('.b-service-card__count-text', $context);
        $text.text(
            declOfNum(parseInt($number.text()), ['сервис', 'сервиса', 'сервисов'])
        )
    })
})